import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="choices"
export default class extends Controller {
  connect() {
    this.bind_plugin();
  }

  bind_plugin() {
    let options = this.element.dataset.choices ? JSON.parse(this.element.dataset.choices) : {};
    let default_options = {
        searchEnabled: false,
        classNames: {
          containerInner: this.element.className,
          list: "none",
          listSingle: "none",
          listDropdown: "dropdown-menu",
          itemChoice: "dropdown-item",
          activeState: "show",
          selectedState: "active"
        }
      };
    let all_options = Object.assign(default_options, options);
    this.choices = new Choices(this.element, all_options);
  }
}
